import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=0006257a&scoped=true"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"
import style0 from "./video.css?vue&type=style&index=0&id=0006257a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0006257a",
  null
  
)

export default component.exports